import { isNil } from "../is-nil";
export var getIsInputValueReset = function getIsInputValueReset(previousValue, value) {
  return !isNil(previousValue) && value === null;
};